import accountSlice from './accounts/slice';
import companySlice from './company/slice';
import userSlice from './user/slice';

export const actions = {
  ...accountSlice.actions,
  ...userSlice.actions,
  ...companySlice.actions,
};
